<template>
  <div class="timeline-handle" @mousedown="handleMouseDown" />
</template>
<script>
import { clamp } from '../../utils';
export default {
  computed: {
    height() {
      return this.$store.state.timelineHeight;
    }
  },
  methods: {
    handleMouseDown(e) {
      this.dragging = true;
      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.handleMouseUp);
      document.body.classList.add('unselectable');
      this.origPos = e.clientY;
      this.orig = this.height;
    },
    /**
     * @param {MouseEvent} e 
     */
    handleMouseMove(e) {
      let offset = e.clientY - this.origPos;
      this.$store.commit('handleTimelineHeight', clamp(this.orig - offset, 180, clamp(window.innerHeight / 2 - 25, 180, 480)));
    },
    handleMouseUp() {
      this.dragging = false;
      document.removeEventListener('mousemove', this.handleMouseMove);
      document.removeEventListener('mouseup', this.handleMouseUp);
      setTimeout(() => {
        document.body.classList.remove('unselectable');
      }, 0);
    },
    handleWindowResize() {
      const height = clamp(this.height, 180, clamp(window.innerHeight / 2 - 25, 180, 480));
      if (height !== this.height) {
        this.$store.commit('handleTimelineHeight', height);
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  }
}
</script>
<style>
.timeline-handle {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: ns-resize;
  transition: 0.3s;
}

.timeline-handle:hover {
  box-shadow: inset 0 3px rgba(0, 0, 0, 0.04);
}
</style>